import useHasPermissions from '@/hooks/useHasPermissions';
import React from 'react';
import NoPermission from './NoPermission';

type Props = {
  permissions: string[];
  children: any;
};

export default function PageWithPermissions({ permissions, children }: Props) {
  const hasPermission = useHasPermissions(permissions);
  if (hasPermission) {
    return children;
  }
  return <NoPermission />;
}
